/**
 * Global constants for AIR Trainer app.
 * These are NOT environment-specific and remain constant across all environments.
 */

import { getInitialParams } from '@frontend/env';

/**
 * AIR Trainer location IDs used for auth-api scoping.
 * Used in Location-Id header and request payloads.
 *
 * These IDs are environment-specific but are constants, not env vars,
 * because they are tightly coupled to the app identity in each environment.
 */
export const AIR_TRAINER_LOCATION_IDS = {
  /** Development environment location ID (weavedev.net) */
  DEV: '897b5b00-57cf-423e-b13e-646ab73880fb',
  /** Production environment location ID (getweave.com) */
  PROD: 'dfbbf8cd-ac87-42be-87fc-2c243272f122',
} as const;

/**
 * Whether the app is using dev backend (weavedev.net).
 * Respects environment switcher (localStorage override).
 *
 * Uses `getInitialParams()` to get the resolved backend API,
 * same as how weave app determines the environment.
 */
export const isDevBackend = (): boolean => {
  const { backendApi } = getInitialParams();
  return backendApi.includes('weavedev.net');
};

/**
 * Get the AIR Trainer location ID for the current environment.
 */
export const getAirTrainerLocationId = (): string => {
  return isDevBackend() ? AIR_TRAINER_LOCATION_IDS.DEV : AIR_TRAINER_LOCATION_IDS.PROD;
};
